import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './pages/inicial/Home.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return {x:0, y:0}
  },
  routes: [
    {
      path: '/emailverify/:hash',
      name: 'emailverify',
      component: () => import(/* webpackChunkName: "emailverify" */ './pages/inicial/EmailVerify.vue')
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: () => import(/* webpackChunkName: "resetpassword" */ './pages/inicial/ResetPassword.vue')
    },
    {
      path: '/resetpassword/:hash',
      name: 'resetpassword_changepassword',
      component: () => import(/* webpackChunkName: "resetpasswordchange" */ './pages/inicial/ResetPasswordChange.vue')
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting            
      component: () => import(/* webpackChunkName: "login" */ './pages/inicial/Login.vue')
    },
    {
      path: '/cadastro',
      name: 'cadastro',
      // route level code-splitting
      component: () => import(/* webpackChunkName: "cadastro" */ './pages/inicial/Cadastro.vue')
    },
    {
      path: '/dashboard',
      //name: 'dashboard',      
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "dashboard_home" */ './pages/dashboard/Home.vue'),
      children: [
        {
          path: 'products',
          //name:'products',
          component: () => import(/* webpackChunkName: "dashboard_products" */ './pages/dashboard/Products.vue'),
          children: [
            {
              path: '',
              name: 'products',
              component: () => import(/* webpackChunkName: "dashboard_proructs_list" */ './pages/dashboard/Products/List.vue'),
            },
            {
              path: 'add',
              name: 'product_add',
              component: () => import(/* webpackChunkName: "dashboard_products_add" */ './pages/dashboard/Products/Add.vue'),
            },
            {
              path: 'addvideo',
              name: 'product_add_video',
              component: () => import(/* webpackChunkName: "dashboard_products_addvideo" */ './pages/dashboard/Products/AddVideo.vue'),
            }
            ,
            {
              path: 'edit/:id',
              name: 'product_edit',
              component: () => import(/* webpackChunkName: "dashboard_products_add" */ './pages/dashboard/Products/Add.vue'),
            },
            {
              path: 'view/:id',
              name: 'product_view',
              component: () => import(/* webpackChunkName: "dashboard_products_add" */ './pages/dashboard/Products/View.vue'),
            },
            {
              path: 'editvideo/:id',
              name: 'product_edit_video',
              component: () => import(/* webpackChunkName: "dashboard_products_addvideo" */ './pages/dashboard/Products/AddVideo.vue'),
            },
            {
            path: 'isrcman/:id',
            name:'isrc_manager',
            component: () => import(/* webpackChunkName: "dashboard_products_isrc" */ './pages/dashboard/Products/ISRC.vue'),
          }
          ]
        },
        {
          path: '',          
          component: () => import(/* webpackChunkName: "dashboard_insights" */ './pages/dashboard/Insights.vue'),
          children:[
            {
              path:'',
              name: 'insights',
              component: () => import(/* webpackChunkName: "dashboard_insights_index" */'./pages/dashboard/Insights/Index.vue')
            }
          ]
        }
        ,
        {
          path: 'reports',          
          component: () => import(/* webpackChunkName: "dashboard_reports" */ './pages/dashboard/Reports.vue'),
          children:[
            {
              path:'',
              name: 'reports',
              component: () => import(/* webpackChunkName: "dashboard_reports_index" */'./pages/dashboard/Reports/Index.vue')
            },
            {
              path:'platform/:platform',
              name: 'reports_platform',
              component: () => import(/* webpackChunkName: "dashboard_reports_platform" */'./pages/dashboard/Reports/Platform.vue')
            }
          ]
        },
        {
          path: 'works',
          //name:'works',
          component: () => import(/* webpackChunkName: "dashboard_works" */ './pages/dashboard/Works.vue'),
          children: [
            {
              path: '',
              name: 'works',
              component: () => import(/* webpackChunkName: "dashboard_works_list" */'./pages/dashboard/Works/List.vue')
            },
            {
              path: 'add',
              name: 'work_add',
              component: () => import(/* webpackChunkName: "dashboard_works_addedit" */'./pages/dashboard/Works/Add.vue')
            },
            {
              path: 'edit/:id',
              name: 'work_edit',
              component: () => import(/* webpackChunkName: "dashboard_works_addedit" */'./pages/dashboard/Works/Add.vue')
            }
          ]
        },
        {
          path: 'payment',          
          component: () => import(/* webpackChunkName: "dashboard_payment" */ './pages/dashboard/Payment.vue'),
          children: [
            {
              path: '',
              name: 'payment',
              component: () => import(/* webpackChunkName: "dashboard_payment_cart" */'./pages/dashboard/Payment/Cart.vue')
            }
          ]
        },
        {
          path: 'settings',          
          component: () => import(/* webpackChunkName: "dashboard_payment" */ './pages/dashboard/Payment.vue'),
          children: [
            {
              path: '',
              name: 'settings',
              component: () => import(/* webpackChunkName: "dashboard_settings" */'./pages/dashboard/Settings.vue')
            }
          ]
        },
        {
          path:'orders',
          component: ()=>import(/* webpackChunkName: "dashboard_orders"*/ './pages/dashboard/Orders.vue'),
          children:[
            {
              path: 'list',
              name:'orders',
              component: ()=> import(/* webpackChunkName: "dashboard_orders_list"*/'./pages/dashboard/Orders/List.vue')
            }
          ]
        },
        {
          path:'invoices',
          component: ()=>import(/* webpackChunkName: "dashboard_invoices"*/ './pages/dashboard/Invoices.vue'),
          children:[
            {
              path: 'list',
              name:'invoices',
              component: ()=> import(/* webpackChunkName: "dashboard_invoices_list"*/'./pages/dashboard/Invoices/List.vue')
            },
            {
              path: 'view/:invoice_id',
              name:'invoice_view',
              component: ()=> import(/* webpackChunkName: "dashboard_invoices_view"*/'./pages/dashboard/Invoices/View.vue')
            }
          ]
        }
      ]
    },
    {
      path:'*',
      name:'notfound',
      component: () => import(/* webpackChunkName: "404" */ './pages/inicial/404.vue'),
    }
  ]
})
